import styled from '@emotion/styled';
import { FC } from 'react';
import { createElement } from 'react';
import * as React from 'react';

type Props = {
  tabName: string;
  value: string;
  children?: React.ReactNode;
};

export const TabPanel: FC<Props> = ({ value, tabName, children }) => {
  return (
    <Root hidden={value !== tabName} key={`tabPanel-${tabName}`}>
      {value === tabName && children}
    </Root>
  );
};

const Root = styled('div')({});
